import templateUrl from './boiler-plate.component.html';
import moment from 'moment';
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import pdfWorker from 'pdfjs-dist/build/pdf.worker.entry';
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

export const StateBoilerPlateComponent = {
    templateUrl,
    controller: StateBoilerPlateController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        employeeBankInfo: "<",
        provinces: "<",
        ownerView: "<",
        close: "&",
        dismiss: "&"
    }
}

function StateBoilerPlateController($scope, $q, $state, $uibModal, $timeout, utilityService, onboardingDocumentService) {
    'ngInject'

    const vm = this;
    vm.stateAbbreviation;
    vm.onSubmit = onSubmit;
    vm.onApprove = onApprove;
    vm.onConfirmChange = onConfirmChange;
    vm.uploadedFile = null;
    vm.onFileChange = onFileChange;
    vm.date;
    vm.title;
    vm.stateTaxedIn;
    vm.uploadedFileName;
    vm.submitted;
    let pdfDoc = null;
    vm.baseScale = 1;
    vm.zoomFactor = 1;
    vm.onRequestReview = onRequestReview;
    vm.zoomIn = () => {
        vm.zoomFactor += 0.1; renderAllPages();
    };
    vm.zoomOut = () => {
        vm.zoomFactor = Math.max(0.1, vm.zoomFactor - 0.1); renderAllPages();
    };



    vm.$onInit = function () {
        if (vm.resolve) {
            Object.assign(vm, vm.resolve);
        }
        vm.title = "State W4 - " + vm.provinces.find(x => x.StateProvinceID === vm.employeeBankInfo.StateToBeTaxedIn)?.StateName;
        vm.submitted = vm.resolve.application.ApplicationStatus === 'Submitted' || vm.resolve.application.ApplicationStatus === 'Approved';
        if (vm.submitted) {
            vm.declaration = true;
        }
        vm.date = moment(new Date(), 'MM/DD/YYYY').toDate();
        vm.stateTaxedIn = vm.provinces.find(x => x.StateProvinceID === vm.employeeBankInfo.StateToBeTaxedIn)?.StateName || '';
        vm.isExemptOnly = vm.provinces.find(x => x.StateProvinceID === vm.employeeBankInfo.StateToBeTaxedIn)?.IsStateExemptOnly || false;
        utilityService.hideLoading();
        if (vm.ownerView && vm.resolve.previewUrl) {
            $timeout(() => waitForContainerAndRender(), 700);
        }
    }

    function onRequestReview() {
        const trans = onboardingDocumentService.saveComment({
            ApplicationId: vm.application.ApplicationId,
            UserName: vm.owner.UserName,
            Text: vm.commentText,
        })
            //.then((res) => {
            //if (res) return onboardingDocumentService.setReviewRequired(vm.employee.EmployeeID, '5');
            //})
            .then(() => {
                vm.close({ $value: 'review' });
            }).catch((err) => {
                return $q.reject(err);
            });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, 'Request review failed')
        );

    }

    function onFileChange(file) {
        $scope.$apply(function () {
            vm.uploadedFileName = '';
            vm.uploadedFile = null;
            const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg'];
            const maxSizeMB = 5;

            if (!allowedTypes.includes(file.type)) {
                alert('Only PDF, PNG, and JPG files are allowed.');
                return;
            }
            if (file.size > maxSizeMB * 1024 * 1024) {
                alert(`File size must be under ${maxSizeMB}MB.`);
                return;
            }
            vm.uploadedFileName = file ? file.name : null;
            vm.uploadedFile = file;
        });
    }


    function onConfirmChange() {
        if (vm.taxForm.declaration) {
            vm.taxForm.declaration.$setValidity('missing', true);
        } else {
            vm.taxForm.declaration.$setValidity('missing', false);
        }
    }

    function onSubmit() {
        utilityService.showLoading();
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        //let submitApplicationPromise = $q.defer();
        //let formData = {
        //    RequestTypeId: '2',
        //    Date: moment(vm.date, 'MM/DD/YYYY').format('MM/DD/YYYY')
        //}
        //let stateAbbr = vm.provinces.find(x => x.StateProvinceID === vm.employeeBankInfo.StateToBeTaxedIn)?.Abbr || '';
        let buildFormData = vm.uploadedFile ? readFileAsBase64(vm.uploadedFile).then(base64 => ({
            RequestTypeId: '2',
            Date: moment(vm.date, 'MM/DD/YYYY').format('MM/DD/YYYY'),
            UploadedFileBase64: base64,
            UploadedFileName: vm.uploadedFile.name,
            UploadedFileType: vm.uploadedFile.type
        })) : $q.resolve({
            RequestTypeId: '2',
            Date: moment(vm.date, 'MM/DD/YYYY').format('MM/DD/YYYY')
        });

        return buildFormData.then(formData =>
            onboardingDocumentService.submit(vm.employee.UserName, formData, vm.employeeBankInfo.StateToBeTaxedIn)
        ).then(() => {
            utilityService.hideLoading();
            vm.close({ $value: 'ok' });
        });

        //submitApplicationPromise = onboardingDocumentService.submit(vm.employee.UserName, formData, stateAbbr, vm.employeeBankInfo.StateToBeTaxedIn, vm.uploadedFile);
        ////to-do: save date and other inputs for not implemented state forms
        //return submitApplicationPromise.then((res) => {
        //    console.log(res);
        //}).then(() => {
        //    utilityService.hideLoading();
        //    vm.close({ $value: 'ok' });
        //});
    }

    function readFileAsBase64(file) {
        let deferred = $q.defer();
        let reader = new FileReader();
        reader.onload = e => deferred.resolve((e.target.result as string).split(',')[1]);
        reader.onerror = () => deferred.reject('File read failed');
        reader.readAsDataURL(file);
        return deferred.promise;
    }

    function onApprove() {
        utilityService.showLoading();
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        if (vm.ownerView) {
            var warningPromise;
            if (vm.showPaperWarning) {
                warningPromise = $uibModal.open({
                    windowClass: 'modal-dialog-centered',
                    template: `<div class="modal-header">
                            </div>
                            <div class="modal-body">
                                <p>{{$ctrl.message}}</p>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-outline-secondary" ng-click="$ctrl.goBack()">Go Back</button>
                                <button class="btn btn-primary" ng-click="$ctrl.continue()">Continue</button>
                            </div>
                        `,
                    controllerAs: '$ctrl',
                    controller: function ($uibModalInstance) {
                        'ngInject';
                        this.message = vm.message;
                        this.continue = () => $uibModalInstance.close(true);
                        this.goBack = () => $uibModalInstance.dismiss();
                    }
                }).result;
            } else {
                warningPromise = Promise.resolve();
            }
            utilityService.showLoading();
            return warningPromise.then(() => {
                onboardingDocumentService.approveOnboardingForm(vm.application.ApplicationId, "2");
            }).then((res) => {
                console.log(res);
                utilityService.hideLoading();
                vm.close({ $value: 'ok' });
            }).catch (() => {
                utilityService.hideLoading();
            });;
        }
    }

    function loadPdf(url) {
        const loadingTask = pdfjsLib.getDocument(url);
        loadingTask.promise.then(function (pdf) {
            pdfDoc = pdf;
            const container = document.getElementById('pdfContainer');
            pdf.getPage(1).then(page => {
                const unscaledViewport = page.getViewport({ scale: 1 });
                vm.baseScale = container.clientWidth / unscaledViewport.width;
                renderAllPages();
            });
        }).catch(function (err) {
            console.log('Error loading PDF:', err);
        });
    }

    function renderAllPages() {
        const container = document.getElementById('pdfContainer');
        if (!container) return;
        container.innerHTML = '';
        for (let pageNumber = 1; pageNumber <= pdfDoc.numPages; pageNumber++) {
            renderPage(pageNumber, container);
        }
    }

    function renderPage(pageNumber, container) {
        pdfDoc.getPage(pageNumber).then(page => {
            const viewport = page.getViewport({ scale: 1 });
            const containerWidth = container.clientWidth;
            if (!containerWidth) return;
            const effectiveScale = (containerWidth / viewport.width) * vm.zoomFactor;
            const scaledViewport = page.getViewport({ scale: effectiveScale });
            const canvas = document.createElement('canvas');
            canvas.className = 'pdf-page-canvas';
            const context = canvas.getContext('2d');
            const dpr = window.devicePixelRatio || 1;
            canvas.width = scaledViewport.width * dpr;
            canvas.height = scaledViewport.height * dpr;
            canvas.style.width = '100%';
            canvas.style.height = scaledViewport.height + 'px';
            context.setTransform(dpr, 0, 0, dpr, 0, 0);
            page.render({ canvasContext: context, viewport: scaledViewport });
            container.appendChild(canvas);
        });
    }

    function waitForContainerAndRender(retries = 30) {
        const container = document.getElementById('pdfContainer');
        if (!container) return;
        const width = container.clientWidth || 0;
        if (width > 300) {
            loadPdf(vm.resolve.previewUrl);
        } else if (retries > 0) {
            $timeout(() => waitForContainerAndRender(retries - 1), 300);
        }
    }
}


export const BoilerPlateW4Modal = {
    component: "apexBoilerPlateW4Modal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}

